import axios from '@/utils/request';

const pointApi = {
  /**
   * 分页查询点位
   * @param {Object} params
   * id: 点位标签
   * @returns Promise
   */
  getPoint(params) {
    return axios({
      url: '/api/v1/point/page',
      method: 'GET',
      params,
    });
  },
  /**
   * 编辑点位
   */
  editPoint(data) {
    return axios({
      url: '/api/v1/point/update',
      method: 'POST',
      data,
    });
  },
  /**
   * 新增点位
   * @param {Object} data
   */
  addPoint(data) {
    return axios({
      url: '/api/v1/point/add',
      method: 'POST',
      data,
    });
  },
  async checkNotExistsPoint(data) {
    return axios({
      url: '/api/v1/point/checkNotExists',
      method: 'post',
      data,
    });
  },

  async tryMapping(data) {
    return axios({
      url: '/api/v1/point/tryMapping',
      method: 'post',
      data,
    });
  },

  getPointDetailList(data, config = {}) {
    return axios({
      url: '/api/v1/point/detail/batch',
      method: 'post',
      data,
      ...config,
    });
  },

  getPointCodeListByPage(params) {
    return axios({
      url: '/api/v1/point/page',
      method: 'get',
      params,
    });
  },
  // 根据设备名返回点位信息接口
  async getPointCodeList(params) {
    return axios({
      url: '/api/v1/point/list',
      method: 'get',
      params,
    });
  },
  // 公共工作单元点位按照独立工作单元分组
  getPointWorkUnitGroup(data) {
    return axios({
      url: '/api/v1/point/public/groupByWorkUnit',
      method: 'post',
      data,
    });
  },
};

export default pointApi;
